module.exports = __webpack_public_path__ + "img/default-avatar.18d911e4.png";